(function (app, ng) {

    app.config([
        "$stateProvider", function ($stateProvider) {
            $stateProvider.state("Home.ROR.Contract",
                {
                    url: "/Contract/:workflow",
                    component: "contract",
                    PageTitle: "Get Contracted",
                    resolve: {
                        userMasterAdvisorAgreement: ["agreementsApi", function (agreementsApi) {
                            return agreementsApi.getLoggedInUserMasterAdvisorAgreement().then(function (agreement) {
                                return agreement;
                            }, function () {
                                return null;
                            });
                        }],
                        userOnbordingRecord: ["onboardingApi", function (onboardingApi) {
                            return onboardingApi.getLoggedInUserOnboarding().then(function (record) {
                                return record;
                            }, function () {
                                return null;
                            });
                        }],
                        sureLcUser: ["ssoApi", function (ssoApi) {
                            return ssoApi.getSureLcUser().then(function (user) {
                                return user;
                            }, function () {
                                return null;
                            });
                        }],
                        onBehalfOfUserGroup: ["userApi", "permissionService", "userGroupApi", function (userApi, permissionService, userGroupApi) {
                            var onBehalfOfUserId = permissionService.getOnBehalfOfUserId();
                            if (onBehalfOfUserId)
                                return userApi.get(onBehalfOfUserId).then(function (user) {
                                    if (user.UserGroupId)
                                        return userGroupApi.get(user.UserGroupId);
                                    return null;
                                });
                            return null;
                        }],
                        rorSteps: ["masterAdvisorAgreementRequiredRecord", "userOnbordingRecord", "userMasterAdvisorAgreement", function (masterAdvisorAgreementRequiredRecord, userOnbordingRecord, userMasterAdvisorAgreement) {
                            var steps = [];

                            if (userOnbordingRecord !== null) {
                                if (masterAdvisorAgreementRequiredRecord !== null)
                                    steps.push({
                                        step: "agreement",
                                        description: "Sign Master Advisor Agreement",
                                        complete: userMasterAdvisorAgreement !== null ? true : false
                                    });

                                steps.push({
                                    step: "validate",
                                    description: "Validate your Personal Information",
                                    complete: userOnbordingRecord.InfoValidated !== null ? true : false
                                });

                                steps.push({
                                    step: "getcontracted",
                                    description: "Get Contracted!",
                                    complete: false
                                });
                            }
                            return steps;
                        }]
                    },
                    params: {
                        workflow: null
                    }
                });
        }
    ]);

    app.component("contract",
        {
            templateUrl: "App/RORWizard/Contract/contract.html",
            controller: contractCtrl,
            bindings: {
                user: "<",
                userGroup: "<",
                onBehalfOfUserGroup: "<",
                rorSteps: "<",
                masterAdvisorAgreementRequiredRecord: "<",
                sureLcUser: "<",
                exportContractReport: "<",
                SubAgents: "<"
            }
        });

    contractCtrl.$inject = ["ssoApi", "externalLoading", "$state", "$stateParams", "$filter", "reportsApi", "amplitudeService", "$scope", "$timeout"];

    function contractCtrl(ssoApi, externalLoading, $state, $stateParams, $filter, reportsApi, amplitudeService, $scope, $timeout) {
        var $ctrl = this;
        var downloadIncrement = 0;

        $ctrl.goToAgreement = $filter("filter")($ctrl.rorSteps, { step: "agreement" }).length && $filter("filter")($ctrl.rorSteps, { step: "agreement" })[0].complete === false ? true : false;

        //if we want to hide when they have already validated:
        //$ctrl.goToValidate = ($filter("filter")($ctrl.rorSteps, { step: "validate" }).length && $filter("filter")($ctrl.rorSteps, { step: "validate" })[0].complete === false) ? true : false;

        //always allow them to go back to validate:
        $ctrl.goToValidate = true;
        ng.extend($ctrl, {
            ui: {
                contractingLoading: false,
                prevStage: $ctrl.goToValidate ? "validate" : $ctrl.goToAgreement ? "agreement" : "steps",
                nextStage: "surelc",
                darkTheme: localStorage.getItem('darkTheme') === 'true' ? true : false,
                exporting: false,
                sideNav: false
            }
        });

        $scope.$on('themeUpdated', function (event, value) {
            $ctrl.ui.darkTheme = value;
        });

        $ctrl.getContracts = function () {
            //$ctrl.ui.contractingLoading = true;
            return reportsApi.getContracts()
                .then(function (data) {
                    //$ctrl.ui.contractingLoading = false;
                    $ctrl.contractData = data;
                    return $ctrl.contractData;
                })
                .finally(function () {
                    //$ctrl.ui.contractingLoading = false;
                    return [];
                });
        };

        $ctrl.changeStage = function (goToStage) {
            if (goToStage === "validate") {
                $state.go("Home.ROR.Validate");
            }
            if (goToStage === "surelc") {
                $ctrl.goToSureLc();
            }
            if (goToStage === "agreement") {
                $state.go("Home.ROR.Agreement", { "workflow": "ror" });
            }
            if (goToStage === "steps") {
                $state.go("Home.ROR.Steps");
            }
        };

        $ctrl.goToSureLc = function () {

            $ctrl.userGroup = $ctrl.onBehalfOfUserGroup || $ctrl.userGroup;

            if ($ctrl.userGroup && $ctrl.userGroup.AffiliationLink) {
                window.open($ctrl.userGroup.AffiliationLink);
            }

            else {
                var w = window.open();
                w.document.write(externalLoading.html);

                ssoApi.initiateSureLcSso($ctrl.sureLcUser.LastName).then(function (data) {
                    w.document.write(data);
                    w.document.forms.surelc.submit();
                }, function (error) {
                    w.document.write(" Failed.  There was an error accessing this resource.");
                }).then(function () {

                    if ($ctrl.workflow === "ror")
                        $state.go("Home.Dashboard", {}, { reload: true });
                });
            }
        };

        $ctrl.getContractDetail = function (contract) {
            if (contract.ShowDetails) {
                contract.ShowDetails = false;
                return;
            }
            amplitudeService.logClickEvent("My Appointments");
            contract.GettingDetails = true;

            reportsApi.getStateAppointments(contract.ContractGuid, contract.LineOfBusinessGuid).then(function (data) {
                contract.GettingDetails = false;
                contract.ContractDetails = data;
                contract.ShowDetails = true;
            });
        };

        $ctrl.getSubAgents = function () {
            reportsApi.getSubAgents().then(function (data) {
                $ctrl.SubAgents = data;
            });
        };


        $ctrl.exportContractReport = function () {
            $ctrl.ui.exporting = true;
            var agentGuids =
                _.map(_.filter($ctrl.SubAgents), "ChildAgentGuid");

            var agentIds = "";
            for (var i = 0; i < agentGuids.length; i++) {
                agentIds += agentGuids[i];
                if (i < agentGuids.length - 1)
                    agentIds += ",";
            }
            var model = { AgentIds: agentIds };

            return reportsApi.exportContractReport(model).then(function (data) {
                $ctrl.ui.exporting = false;

                downloadFile(data);
            });
        };

        function downloadFile(data) {
            var f = document.createElement("a");
            f.id = "tmpDownload-" + ++downloadIncrement;
            document.body.appendChild(f);
            f.style = "display: none";

            var fUrl = window.URL.createObjectURL(data);
            f.href = fUrl;
            f.download = "ContractData.xlsx";
            f.click();

            setTimeout(function () {
                var el = document.getElementById(f.id);
                document.body.removeChild(el);
                window.URL.revokeObjectURL(fUrl);
            },
                100);
        }
        $ctrl.$onInit = function () {
            $ctrl.workflow = $stateParams.workflow;
            $ctrl.ui.contractingLoading = true;
            $ctrl.getContracts()
                .finally(function () {
                    $ctrl.ui.sideNav = true;
                    $ctrl.ui.contractingLoading = false;
                });
                //.then(function (response) {
                //    $ctrl.ui.sideNav = true;
                //    $timeout(function () {
                //        window._wq = window._wq || [];
                //        _wq.push({
                //            id: 'q4kvg1saon', onReady: function (video) {
                //                if (!response || response.length < 1) {
                //                    video.play();
                //                } else {
                //                    $("#sureLC_video").removeClass('popover=true');
                //                    $("#sureLC_video").addClass('popover=false');
                //                }
                //            }
                //        });

                //    }, 3500);
                //})
                //.catch(function (error) {
                //    $ctrl.ui.sideNav = false;
                //    window._wq = window._wq || [];
                //    _wq.push({
                //        id: 'q4kvg1saon', onReady: function (video) {
                //            video.play();
                //        }
                //    });
                //})
                //.finally(function () {
                //    $ctrl.ui.contractingLoading = false;
                //});
            $ctrl.getSubAgents();
        };
    }
})(window.app, window.angular); // jshint ignore:line